import { useEffect } from 'react'
import { useSearchParams } from 'react-router'
import { CONNECTORS } from '@/components/connectors/consts'
import { useToast } from '@/hooks/useToast'

const CONNECTED_PARAM = 'connected'

export const useConnectorConnectedToast = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const { toast } = useToast()

  const connectedId = searchParams.get(CONNECTED_PARAM)

  useEffect(() => {
    if (!connectedId) {
      return
    }

    const connector = Object.values(CONNECTORS).find(
      (connector) => connector.id === connectedId
    )

    if (connector) {
      toast({ title: `Connected to ${connector.name}` })
    }

    setSearchParams(
      (params) => {
        params.delete(CONNECTED_PARAM)

        return params
      },
      { replace: true }
    )
  }, [connectedId, setSearchParams, toast])
}
